import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Technology } from '../types/technology.types';
@Injectable({
  providedIn: 'root',
})
export class TechnologyService {
  constructor(private http: HttpClient) {}

  public searchTechnologies(searchString: string) {
    return this.http.get<Technology[]>(environment.apiUrl + '/technologies/?search_str=' + searchString);
  }

  public getAllTechnologies() {
    return this.http.get<Technology[]>(environment.apiUrl + '/technologies/');
  }
}
